import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropBoxService {
  constructor(private _httpClient: HttpClient, @Inject('env') private _env: any) {}

  public upload(files: File[]) {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file, file.name);
    });

    return this._httpClient.post<any>(`${this._env.apiURL}/Files/Upload`, formData);
  }
}
